import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserCreatePage } from './user-create.component';
import { authGuard } from '@guards/auth.guard';
import { hasRoleGuard } from '@guards/has-role.guard';

const routes: Routes = [
  {
    path: 'users/create',
    component: UserCreatePage,
    canActivate: [authGuard, hasRoleGuard(null, ['create_user'])],
    data: {
      title: "Crear nuevo usuario"
    }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserCreatePageRoutingModule { }
